import Link from 'next/link'
import Image from 'next/image'

interface IProductOptionsSummaryProps {
  productName: string
  pdpSlug: string
  imageUrl: string
  selectedOptions: { name: string; value: string | number }[]
}

function ProductOptionsSummary({
  productName,
  pdpSlug,
  imageUrl,
  selectedOptions,
}: IProductOptionsSummaryProps) {
  return (
    <div className="flex flex-col gap-6 bg-white rounded-xl px-[24px] py-[18px] w-full border-2 border-black-20">
      <div className="flex flex-row gap-4 justify-between items-center">
        <h2 className="text-xl font-semibold text-black">{productName}</h2>
        <Link href={pdpSlug} className="text-xl text-black-80 underline">
          Edit
        </Link>
      </div>

      <div className="flex flex-row gap-8 justify-start items-start">
        {imageUrl && (
          <div className="hidden lg:flex rounded-full h-40 w-40">
            <Image src={imageUrl} alt={productName} width={100} height={100} />
          </div>
        )}

        <div className="flex flex-col gap-2">
          {selectedOptions.map((option) => (
            <p key={option.name} className="text-xl !leading-[18px]">
              <span className="font-bold capitalize text-black">
                {option.name}&nbsp;
              </span>
              <span className="text-black-80">{option.value}</span>
            </p>
          ))}
        </div>
      </div>
    </div>
  )
}

export { ProductOptionsSummary }

export type { IProductOptionsSummaryProps }
